import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
    factors: [],
    factor: {},
    loading: true,
    error: null,
};

const getters = {
    factors: state => state.factors,
    factor: state => state.factor,
    loading: state => state.loading,
    error: state => state.error,
};

const mutations = {
    setFactors: (state, payload) => { state.factors = payload; },
    setFactor: (state, payload) => { state.factor = payload; },
    setLoading: (state, payload) => { state.loading = payload; },
    setError: (state, payload) => { state.error = payload; },
};

const actions = {
    async get({ commit }) {
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/';

        return axios.get(request_url)
            .then(function (response) {
                output = true;
                commit('setFactors', response.data.data);
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    async getExclusionFactors({ commit }) {
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/exclusion';

        return axios.get(request_url)
            .then(function (response) {
                output = true;
                commit('setFactors', response.data.data);
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    async getCalculationFactors({ commit }) {
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/calculation';

        return axios.get(request_url)
            .then(function (response) {
                output = true;
                commit('setFactors', response.data.data);
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    async getById({ commit }, id) {
        commit('setLoading', true);
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/' + id;

        return axios.get(request_url)
            .then(function (response) {
                output = true;
                commit('setFactor', response.data.data);
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    async create({ commit }, payload) {
        commit('setLoading', true);
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/';

        var requestConfig = {
            method: 'POST',
            url: request_url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        }

        return axios(requestConfig)
            .then(function (response) {
                output = true;
                commit('setFactor', response.data.data);
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    async update({ commit }, payload) {
        commit('setLoading', true);
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/' + payload.id;

        var requestConfig = {
            method: 'PUT',
            url: request_url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        }

        return axios(requestConfig)
            .then(function (response) {
                output = true;
                commit('setFactor', response.data.data);
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    async delete({ commit }, payload) {
        commit('setLoading', true);
        let output = false;
        let request_url = Vue.prototype.$scheduling_api + 'factors/' + payload;

        var requestConfig = {
            method: 'DELETE',
            url: request_url,
            headers: {
                'Content-Type': 'application/json'
            }
        }

        return axios(requestConfig)
            .then(function (response) {
                // 204 response status represents success
                output = response.status == 204;
                if (!output) {
                    commit('setError', response.data.message);
                }
            })
            .catch(function (error) {
                commit('setError', error.response ? error.response.data.error.message : error);
                output = false;
            })
            .then(function () {
                commit('setLoading', false);
                return output;
            });
    },

    clearError({ commit }) {
        commit('setError', null);
    },

    // Reset store to its initial state
    reset({ commit }) {
        commit('setFactors', null);
        commit('setLoading', true);
        commit('setError', null);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};